import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Container, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { handleResponse } from '../utils/handlers';

import styles from './ChargingNotes.module.css';

function ChargingNotes(props) {

    let history = useHistory();

    const { consignmentId } = useParams();

    const [chargingNotes, setChargingNotes] = useState(history.location.state || '');
    const [busy, setBusy] = useState(false);

    function saveNote() {

        setBusy(true);

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        fetch(`api/consignments/${consignmentId}/chargingnotes`, {
            credentials: 'include',
            method: 'POST',
            headers: headers,
            body: JSON.stringify({chargingNotes: chargingNotes})
            })
            .then(handleResponse)
            .then(data => {
                setBusy(false);
                alert('Saved');
            })
            .catch(error => {
                console.log(error);
                setBusy(false);
            });
    }

    return (
        <React.Fragment>
            <Container>
                <Form onSubmit={null}>
                    <FormGroup row>
                        <Label>Charging Notes</Label>
                        <Input type="textarea" value={chargingNotes} onChange={e => setChargingNotes(e.target.value)} />
                    </FormGroup>
                    </Form>
            </Container>
            <Button color="primary" onClick={e => saveNote()} block>Save</Button>
            <Button color="primary" onClick={e => history.push(`/consignment/${consignmentId}`)} block>Back</Button>
            <BusyIndicator isBusy={busy} />
        </React.Fragment>
        );
}

export { ChargingNotes };